webpackJsonp([3],{

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__ = __webpack_require__(614);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e045694_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e045694"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e045694_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(582)(true);
// imports


// module
exports.push([module.i, "main{float:right;height:100vh;background-color:#fff}img,main{width:100%}.notfound h1{font-size:164px;margin-top:-138px;text-align:center;color:#ededed}.textnot>div{text-align:center;width:100%;float:right;margin-top:-30px;font-size:24px;font-weight:900;direction:ltr;color:#a5a5a5;position:relative;z-index:9999}.adsaf{cursor:pointer}.adsaf:hover{color:#000}@media (max-width:550px){.notfound h1{margin-top:-64px}}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/assets/css/Error.min.css"],"names":[],"mappings":"AAAA,KACE,YAAa,AACb,aAAc,AACd,qBAAuB,CAExB,AAED,SAHE,UAAY,CAKb,AAED,aACE,gBAAiB,AACjB,kBAAmB,AACnB,kBAAmB,AACnB,aAAe,CAChB,AAED,aACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,YAAc,CACf,AAED,OACE,cAAgB,CACjB,AAED,aACE,UAAY,CACb,AAED,yBACE,aACE,gBAAkB,CACnB,CACF","file":"Error.min.css","sourcesContent":["main {\n  float: right;\n  height: 100vh;\n  background-color: #fff;\n  width: 100%;\n}\n\nimg {\n  width: 100%;\n}\n\n.notfound h1 {\n  font-size: 164px;\n  margin-top: -138px;\n  text-align: center;\n  color: #ededed;\n}\n\n.textnot > div {\n  text-align: center;\n  width: 100%;\n  float: right;\n  margin-top: -30px;\n  font-size: 24px;\n  font-weight: 900;\n  direction: ltr;\n  color: #a5a5a5;\n  position: relative;\n  z-index: 9999;\n}\n\n.adsaf {\n  cursor: pointer;\n}\n\n.adsaf:hover {\n  color: #000;\n}\n\n@media (max-width: 550px) {\n  .notfound h1 {\n    margin-top: -64px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Error404',
  methods: {
    GoBack: function GoBack() {
      window.history.go(-1);
    }
  }
});

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(682);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(583)("58d38514", content, true, {});

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(582)(true);
// imports
exports.i(__webpack_require__(596), "");

// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Error404.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"textnot"},[_c('div',[_c('span',[_vm._v("Sorry About That!")]),_c('span',{staticClass:"adsaf",on:{"click":function($event){return _vm.GoBack()}}},[_c('b',[_vm._v(" Return Back?")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound col-md-6 m-auto d-table"},[_c('img',{attrs:{"src":__webpack_require__(684),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("404")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.f53c1af.gif";

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.96323c6aafe01739a151.js